export const sortArray = (array, key, descending) => {
  return array.sort((a, b) => {
    if (descending) {
      return b[key].toDate() - a[key].toDate();
    } else {
      return a[key].toDate() - b[key].toDate();
    }
  });
};
